<template>
  <div class="resumo-veiculo mt-2">
    <div class="d-flex align-center flex-wrap" style="gap: 8px">
      <div class="text-subtitle-2">
        {{ $t('equipment.panel.vehicleSummary.title', { vehicle: codVeiculo || idVeiculo, count: equipamentos.length }) }}
      </div>
      <AjudaTooltip :texto="$t('equipment.help.vehicleSummary')" />
      <v-chip v-if="resumo.divergencia" small dark color="red darken-1">
        {{ $t('statusDispositivos.vehicleComm.divergence') }}
      </v-chip>
      <v-spacer></v-spacer>
      <v-progress-circular v-if="loading" indeterminate size="18" width="2" color="primary"></v-progress-circular>
      <!-- Comunicação do veículo por fonte: o que o Merus recebe × o que cada integração diz. -->
      <template v-else>
        <span class="resumo-veiculo__fonte">
          <v-icon small :color="corMerus(resumo.merusOffline)">{{ iconeMerus(resumo.merusOffline) }}</v-icon>
          {{ $t('statusDispositivos.vehicleComm.merus') }}: {{ fmtMerus(resumo.merusOffline) }}
          <span v-if="resumo.dtMerus" class="grey--text">({{ fmtDataHora(resumo.dtMerus) }})</span>
        </span>
        <span v-if="resumo.temGeotab" class="resumo-veiculo__fonte">
          <v-icon small :color="corGeotab(resumo.statusGeotab)">{{ iconeGeotab(resumo.statusGeotab) }}</v-icon>
          {{ $t('statusDispositivos.vehicleComm.geotab') }}: {{ fmtGeotab(resumo.statusGeotab) }}
        </span>
        <span v-if="resumo.temFaceid" class="resumo-veiculo__fonte">
          <v-icon small :color="corComunicacao(resumo.statusFaceid)">{{ iconeComunicacao(resumo.statusFaceid) }}</v-icon>
          {{ $t('statusDispositivos.vehicleComm.faceid') }}: {{ fmtStatusComunicacao(resumo.statusFaceid) }}
        </span>
      </template>
    </div>

    <div v-if="!equipamentos.length" class="text-caption grey--text mt-1">
      {{ $t('equipment.panel.vehicleSummary.empty') }}
    </div>
    <div v-else class="d-flex flex-wrap mt-1" style="gap: 6px">
      <v-tooltip v-for="e in equipamentos" :key="e.id_equipamento" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip v-bind="attrs" v-on="on" small outlined :class="{ 'resumo-veiculo__inativo': e.ativo != 1 }"
            @click="$emit('abrir', { classe: classeDe(e), item: e })">
            <v-icon small left>{{ iconeClasse(e) }}</v-icon>
            {{ e.nome_equipamento || e.cod_equipamento }}
            <v-icon x-small right :color="corComunicacao(e.status)">mdi-circle</v-icon>
          </v-chip>
        </template>
        <div>{{ e.nome_tipo_equipamento }} · {{ e.cod_equipamento }}</div>
        <div>
          {{ $t('equipment.headers.main.status') }}: {{ fmtStatusComunicacao(e.status) }}
          <span v-if="e.dt_ultima_atualizacao_comunicacao">({{ fmtDataHora(e.dt_ultima_atualizacao_comunicacao) }})</span>
        </div>
        <div v-if="e.suite_efetiva">
          {{ $t('statusDispositivos.headers.suite') }}: {{ e.nome_suite_efetiva || e.suite_efetiva }} ·
          {{ fmtResultadoSincronizacao(e.status_ultima_sincronizacao) }}
        </div>
        <div v-if="e.ativo != 1">{{ $t('equipment.panel.inactive') }}</div>
        <div class="text-caption">{{ $t('equipment.panel.vehicleSummary.clickHint') }}</div>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import apiController from '@/utils/apiController';
import AjudaTooltip from './AjudaTooltip.vue';
import dispositivosFormatters from './Validadores/dispositivosFormatters';
import comunicacaoVeiculo, { resumoComunicacao } from './comunicacaoVeiculo';
import { classeDoEquipamento, ICONE_CLASSE } from './equipamentosClasses';

export default {
  name: 'ResumoVeiculo',
  components: { AjudaTooltip },
  mixins: [dispositivosFormatters, comunicacaoVeiculo],
  props: {
    idVeiculo: { type: [Number, String], required: true },
    codVeiculo: { type: String, default: null },
    // Todos os equipamentos do veículo, de todas as classes.
    equipamentos: { type: Array, default: () => [] },
  },
  data: () => ({
    loading: false,
    linhas: [],
  }),
  computed: {
    resumo() {
      return resumoComunicacao(this.linhas);
    },
  },
  watch: {
    idVeiculo: {
      immediate: true,
      handler() {
        this.carrega();
      },
    },
  },
  methods: {
    classeDe(item) {
      return classeDoEquipamento(item);
    },
    iconeClasse(item) {
      return ICONE_CLASSE[classeDoEquipamento(item)];
    },
    carrega() {
      if (this.idVeiculo == null) return;
      this.loading = true;
      apiController.request(apiController.endpoints.getStatuscomunicacaoequipamentosporveiculo, {
        query: { id_veiculo: this.idVeiculo },
        silent: true,
        onSuccess: (response) => {
          this.linhas = response.data || [];
        },
        onError: () => {
          this.linhas = [];
        },
      })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.resumo-veiculo__inativo {
  opacity: 0.6;
}
.resumo-veiculo__fonte {
  font-size: 0.8rem;
  white-space: nowrap;
}
</style>
